import { Component, OnInit, Input, Output, forwardRef, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ControlValueAccessor, Validators } from '@angular/forms';



@Component({
  selector: 'app-addressLines',
  templateUrl: './addressLines.component.html',
  styleUrls: ['./addressLines.component.scss'],
   providers: [
    {
      provide: NG_VALIDATORS, useExisting: AddressLinesComponent, multi: true
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AddressLinesComponent),
      multi: true
    }] 
})
export class AddressLinesComponent implements OnInit {
  @Input() controllerData;
  @Input() parent: UntypedFormGroup;
  @Input() pageName:string;
  @Input() controlName:string;
  textValue:string;
  

  @Output() textChangeEventEmitter: EventEmitter<string> = new EventEmitter<string>();
  /**
   * This is a constructor
   */
  constructor(private fb: UntypedFormBuilder) {
  
  }

  ngOnInit() {
    
    if (this.controllerData.validationRule) {
    }

    if(this.parent.get([this.controlName]) && this.pageName == 'beneficiaryDetails'){
      this.textValue = this.parent.get([this.controlName]).value;
    }
    else{
      this.textValue = this.controllerData.value;
    }

  }

  inputTextChangeHandler(val){
    this.textChangeEventEmitter.emit(val);
  }

  validate() {
    // tslint:disable-next-line: max-line-length
    const nameReForpostCode: RegExp = /^[a-z][a-z\s]*$/;
    const forbidden = nameReForpostCode.test(this.parent.get(this.controlName).value);
    

    if (this.parent.get(this.controlName).value) {
      return forbidden ? null : { notValidname: true};
      // tslint:disable-next-line:align
      } return null;
  }
  /* validateInput = () => {
    this.onChangeHandler.emit();
  } */

}
